<template>
    <div>
    <v-card class="mx-auto" light :loading="loading">
        <v-card-title>
            <div class="flex-grow-1"></div>
            <v-card-actions>
                <v-btn small color="blue-grey" dark @click="agregar = true">Agregar</v-btn>
            </v-card-actions>
        </v-card-title>
    <div style=" display: flex; align-items: center; justify-content: end;"> 
      <v-col cols="6" >
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Buscar"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </div>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="cajas"
                :search="search"
                locale="es-mx"
                disable-sort
                :footer-props="{
                    'items-per-page-all-text':'Todos',
                    'items-per-page-text':'Columnas'
                }"
            >
             <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.name">
                        <td>
                            <v-menu>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="caja=item,mostrar=true">
                                        <v-list-item-title>Mostrar Caja</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="caja=item;etiquetas=true">
                                        <v-list-item-title>Imprimir Etiqueta</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{item.numero}}</td>
                        <td>{{fecha(item.fechaInicio)}}</td>
                        <td>{{fecha(item.fechaFin)}}</td>
                        <td>{{item.tipoDocumental}}</td>
                        <td>{{item.dependenciaGeneradora.nombre}}</td>
                        <td> {{item.unidadAdministrativa.nombre}}</td>
                        <td> {{item.expedientes.length}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-card-text>
        
            
    </v-card>
    
    <agregar-caja v-if="agregar" :mostrar="agregar" :tipoCaja="'nueva'" @cancelar="agregar=false" @cajaAgregada="cajaAgregada"/>
    <consultar-caja v-if="mostrar" :caja="caja" :mostrar="mostrar" @cancelar="mostrar=false"/>
    <etiquetas-caja v-if="etiquetas" :etiqueta="etiquetas" @close="etiquetas=false" :idCaja="caja._id"/>
    
</div>
</template>
<script>
import {getCajasService} from './archivo.service'
import AgregarCaja from './agregarCaja.vue'
import {DateTime} from 'luxon'
import ConsultarCaja from './consultarCaja.vue';
import EtiquetasCaja from '../expedientes/etiquetasCajas.vue';
export default {
    components: {
        AgregarCaja,
        ConsultarCaja,
        EtiquetasCaja
    },
    data: () => ({
        loading: false,
        cajas:[],
        caja:{},
        search:'',
        etiquetas:false,
        headers: [
            { text: 'Opciones', value: 'options'},
            { text: 'Número', value: 'numero' },
            { text: 'Fecha de apertura', value: 'fechaInicio' },
            { text: 'Fecha de cierre', value: 'fechaFin' },
            { text: 'Tipo documental', value: 'tipoDocumental' },
            { text: 'Generó', value: 'dependenciaGeneradora.nombre' },
            { text: 'Unidad Administrativa', value: 'unidadAdministrativa.nombre' },
            { text: 'Expedientes', value: 'expedientes'}
        ],
        agregar:false,
        mostrar:false
       
    }),
    computed: {
        
    },
    async created(){
       try {
            this.loading=true;
            const serverResponse = await getCajasService();
            this.loading=false;
            if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
            this.cajas = serverResponse.cajas
        } catch (error) {
            this.$notificarError(error);
        }
       
    },
    methods: {
        cajaAgregada(caja){
            this.cajas.push(caja)
        },
        fecha(fecha){
            return DateTime.fromISO(fecha).toFormat('dd - MM - yyyy')
        }
    }
}
</script>